import { render } from "./Presentismo.vue?vue&type=template&id=1c1d484a&scoped=true"
import script from "./Presentismo.vue?vue&type=script&lang=js"
export * from "./Presentismo.vue?vue&type=script&lang=js"

import "./Presentismo.vue?vue&type=style&index=0&id=1c1d484a&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1d484a"]])

export default __exports__